import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: _ctx.title,
    loading: _ctx.loading,
    onSubmit: _ctx.onSubmit,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_new_input, {
        placeholder: "Цена",
        disabled: _ctx.loading,
        value: _ctx.payload.cost,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payload.cost) = $event)),
        "is-invalid": _ctx.validation$.cost.$error,
        "validation-errors": _ctx.validation$.cost.$errors
      }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
      _createVNode(_component_file_reader, {
        class: "mt-2",
        placeholder: "Фото чеков",
        value: _ctx.payload.checks,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payload.checks) = $event)),
        "is-invalid": _ctx.validation$.checks.$error,
        "validation-errors": _ctx.validation$.checks.$errors,
        multiple: ""
      }, null, 8, ["value", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["title", "loading", "onSubmit", "onCancel"]))
}